import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useGetPcrUploads } from "#/lib/api/pcr-upload";
import { PaginatedSearchSchema } from "#/lib/schemas/paginated-search";
import { PcrUploadsPage } from "#/components/pages/pcr-uploads/pcr-uploads-page";
import { useTenant } from "#/contexts/TenantContext";
import { useMarket } from "#/contexts/MarketContext";
import { useLegacyBackendUrl } from "#/hooks/use-legacy-url";

export const Route = createFileRoute("/$tenantCode/$market/pcr-uploads")({
  beforeLoad: () => ({ getTitle: () => m["resources.pcrUpload.name"]() }),
  validateSearch: PaginatedSearchSchema,
  component: PcrUploadsRoute,
});

function PcrUploadsRoute() {
  const { page, perPage, sort } = Route.useSearch();
  const { tenant } = useTenant();
  const market = useMarket();
  const legacyBackendUrl = useLegacyBackendUrl();

  const [sortField, sortDirection] = (() => {
    if (sort === undefined || sort === "") {
      return [undefined, undefined];
    }
    const parts = sort.split(".");
    if (parts.length !== 2) return [undefined, undefined];
    const [field, direction] = parts;
    if (direction !== "asc" && direction !== "desc") {
      return [undefined, undefined];
    }
    return [field, direction.toUpperCase()];
  })();

  const { data, isLoading } = useGetPcrUploads({
    page,
    perPage,
    sortField,
    sortDirection,
  });

  const backendFilesUrl =
    legacyBackendUrl !== "" ? `${legacyBackendUrl}/tmp_pcr` : undefined;

  const uploads = data?.member ?? [];
  const totalItems = data?.totalItems ?? 0;
  const pageCount = Math.ceil(totalItems / perPage);

  return (
    <PcrUploadsPage
      uploads={uploads}
      pageCount={pageCount}
      isLoading={isLoading}
      backendFilesUrl={backendFilesUrl}
      tenantCode={tenant.code}
      market={market}
    />
  );
}
